export const videos = [
  {
    _id: "iEJPDYrLtsI",
    title: "Ishq Shava",
    description: "Full Song | Jab Tak Hai Jaan | Shah Rukh Khan, Katrina | A R Rahman, Gulzar, Shilpa Rao",
    views: "99875023",
    uploadDate: "Jan 5, 2013",
    category: "Hip-hop",
    channel: "YRF",
    channelThumbnail: "https://yt3.ggpht.com/b42QCAmVJ0kzNNi10_HmhsdfPEATQATS80hbLyHVJcVm6drn5pKtC6MY6wTluXi5iZ8_is5Q_Q=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "s36IMcNP8vo",
    title: "Albela Sajan",
    description: "Full Video Song | Bajirao Mastani | Shashi Suman, Kunal Pandit, Prithvi Gandharva, Kanika Joshi, Rashi Raagga, Geetikka Manjrekar | Sanjay Leela Bhansali",
    views: "12571424",
    uploadDate: " May 4, 2016",
    category: "Classical",
    channel: "Eros Now Music",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu9aZYKOW6IdpFeDyetrTJgHUu7S5WTmSLDlXAXym_4=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "vgm1u2gPxzw",
    title: "Raanjhanaa Hua Mai",
    description: "Video Song | Raanjhanaa | Dhanush | Sonam Kapoor",
    views: "64822795",
    uploadDate: "Aug 12, 2013",
    category: "Bollywood",
    channel: "Eros Now Music",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu9aZYKOW6IdpFeDyetrTJgHUu7S5WTmSLDlXAXym_4=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "IcrbM1l_BoI",
    title: "Wake Me Up",
    description: "Avicii - Official Video",
    views: "2181318560",
    uploadDate: "Jul 29, 2013",
    category: "Electronic",
    channel: "Avicii",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu9gtZe7Pd12rB7dlZP1u0BQ0Po8Py3-_JHLfNypyA=s48-c-k-c0x00ffffff-no-rj-mo"
  },
  {
    _id: "tzRFLMn4kpM",
    title: "Pinga",
    description: "Video Song | Bajirao Mastani | Deepika Padukone and Priyanka Chopra | Shreya Ghoshal",
    views: "283672019",
    uploadDate: "May 4, 2016",
    category: "Bollywood",
    channel: "Eros Now Music",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu9aZYKOW6IdpFeDyetrTJgHUu7S5WTmSLDlXAXym_4=s176-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "gQlMMD8auMs",
    title: "Pink Venom",
    description: "BLACKPINK - Music Video",
    views: "324621935",
    uploadDate: "Aug 19, 2022",
    category: "K-Pop",
    channel: "BLACKPINK",
    channelThumbnail: "https://yt3.ggpht.com/hZDUwjoeQqigphL4A1tkg9c6hVp5yXmbboBR7PYFUSFj5PIJSA483NB5v7b0XVoTN9GCku3tqQ=s48-c-k-c0x00ffffff-no-nd-rj"
  },
  {
    _id: "iywXK9Dj2o4",
    title: "Morirò da Re",
    description: "Officical music video - Måneskin",
    views: "77965523",
    uploadDate: "Mar 26, 2018",
    category: "Rock",
    channel: "Måneskin Official",
    channelThumbnail: "https://yt3.ggpht.com/q3YuUOXEKJB_A9XJ1_jom1O5gjHe0765bNaAr6I7AVMVu9-WFLC4iWV5axD7rztFxPwkuJ0kzqk=s48-c-k-c0x00ffffff-no-nd-rj"
  },
  {
    _id: "4nCshJBODT4",
    title: "Azadi",
    description: "Gully Boy| Ranveer Singh & Alia Bhatt | DIVINE | Dub Sharma | Siddhant | Zoya Akhtar",
    views: "65126511",
    uploadDate: "Feb 11, 2019",
    category: "Hip-hop",
    channel: "Zee Music Company",
    channelThumbnail: "https://yt3.ggpht.com/EEGERwlaKJd27zSEPQF3d__-tPyppIgFfKvNfBkWa7ssMKBWqQUbuCTLe-kAnTB1r6kJQVxyxwY=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "d_HlPboLRL8",
    title: "Runaway",
    description: "Official music video - AURORA",
    views: "462212395",
    uploadDate: "Feb 27, 2015",
    category: "Pop",
    channel: "AURORA",
    channelThumbnail: "https://yt3.ggpht.com/fmEEBMDRdxuvCIUcwRY0EouK4OjK_ai5wUKsW7ZLAjv32Ult_qFDoJnylTLldDCCRDaCXqh9-g=s48-c-k-c0x00ffffff-no-nd-rj"
  },
  {
    _id: "gdZLi9oWNZg",
    title: "Dynamite",
    description: "BTS - Official music video",
    views: "1566506982",
    uploadDate: "Aug 21, 2020",
    category: "K-Pop",
    channel: "HYBE LABELS",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu9_QkJFEa-xNihtl6W2gSoHeZOocElDWPiAzoFokw=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "gCYcHz2k5x0",
    title: "Animals",
    description: "Martin Garrix - Official Video",
    views: "1586764236",
    uploadDate: "Jun 17, 2013",
    category: "Electronic",
    channel: "Spinnin' Records",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu9ppdgul4nVU7Z1bix1Bj6GiuB8zNKJUPKVzOsBkg=s176-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "k8Yn6c7k7Qw",
    title: "Bole Chudiyan",
    description: "Full Video - K3G | Amitabh, Shah Rukh, Kajol, Kareena, Hrithik | Udit Narayan",
    views: "159158486",
    uploadDate: "Jun 14, 2016",
    category: "Bollywood",
    channel: "SonyMusicIndiaVEVO",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu8yf1gliJiSD3sWZU3RfwDbFSxFLioF0xggBRwMyw=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "NTHz9ephYTw",
    title: "Kar Gayi Chull",
    description: "Kapoor & Sons | Sidharth Malhotra | Alia Bhatt | Badshah | Amaal Mallik |Fazilpuria",
    views: "414783906",
    uploadDate: "Feb 17, 2016",
    category: "Party",
    channel: "Sony Music India",
    channelThumbnail: "https://yt3.ggpht.com/vJEsALWnQIwPZ2oaVbFWPu1n4L0CDkHpAdGJ-KBPFsxM9hsMsvExFK1mnCGUrMzfC67XPVThmQ=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "QPGmwRNkffc",
    title: "Doori",
    description: "Gully Boy | Ranveer Singh & Alia Bhatt | Javed Akhtar | DIVINE | Rishi Rich | Zoya Akhtar",
    views: "35077693",
    uploadDate: "Jan 28, 2019",
    category: "Hip-hop",
    channel: "Zee Music Company",
    channelThumbnail: "https://yt3.ggpht.com/EEGERwlaKJd27zSEPQF3d__-tPyppIgFfKvNfBkWa7ssMKBWqQUbuCTLe-kAnTB1r6kJQVxyxwY=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "KBtk5FUeJbk",
    title: "Cradles",
    description: "Sub Urban - Official Music Video",
    views: "557133686",
    uploadDate: "Oct 9, 2019",
    category: "Indie",
    channel: "Sub Urban",
    channelThumbnail: "https://yt3.ggpht.com/2xRfPHQQgRIBkuDKGeaqJ8hQ9B0Pqx0ox7nzmNwH5WfRGKskyy6GkIeGYnlKinEpYcthknR1Tw=s48-c-k-c0x00ffffff-no-nd-rj"
  },
  {
    _id: "uv9Dv6fzg9w",
    title: "Dholida",
    description: "Full Music Video | Gangubai Kathiawadi | Sanjay Leela Bhansali | Alia Bhatt",
    views: "16831141",
    uploadDate: "Apr 14, 2022",
    category: "Bollywood",
    channel: "Saregama Music",
    channelThumbnail: "https://yt3.ggpht.com/AaPtIGuI2O3dC7Jw4HGWo8n4fD-7PT3XPQMG3K_fNbNTpHDjrqqC83AalD1pmPyv2lKdBxi71g=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "HhjHYkPQ8F0",
    title: "Alone, Pt. II",
    description: "Alan Walker & Ava Max - Full Music Video",
    views: "272142547",
    uploadDate: "Dec 27, 2019",
    category: "Electronic",
    channel: "Alan Walker",
    channelThumbnail: "https://yt3.ggpht.com/aVVgun46AV1oXiN5TJh3lmsuWr2bKU2LW1163WB0GsZrthm4wfof6Lq8OVH5qOLq9zOQg8yj=s48-c-k-c0x00ffffff-no-nd-rj"
  },
  {
    _id: "YqeW9_5kURI",
    title: "Lean On",
    description: "Major Lazer & DJ Snake - feat. MØ | Official Music Video",
    views: "3259340398",
    uploadDate: "Mar 23, 2015",
    category: "Pop",
    channel: "Major Lazer Official",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu8SlgFjyufiqMbx6WOwJEbh5Wl0Bz2FaBD0pomtxg=s48-c-k-c0x00ffffff-no-rj-mo"
  },
  {
    _id: "QN1odfjtMoo",
    title: "Zitti E Buoni",
    description: "Måneskin - Official Video | Sanremo & EUROVISION 2021 Winners",
    views: "148588788",
    uploadDate: "Mar 3, 2021",
    category: "Rock",
    channel: "Måneskin Official",
    channelThumbnail: "https://yt3.ggpht.com/q3YuUOXEKJB_A9XJ1_jom1O5gjHe0765bNaAr6I7AVMVu9-WFLC4iWV5axD7rztFxPwkuJ0kzqk=s48-c-k-c0x00ffffff-no-nd-rj"
  },
  {
    _id: "lL0ULDPCqIA",
    title: "Mere Dholna",
    description: "Bhool Bhulaiyaa | Vidya Balan | Shreya Ghoshal, M.G. Sreekumar | Pritam",
    views: "20703261",
    uploadDate: "Apr 6, 2020",
    category: "Classical",
    channel: "T-Series",
    channelThumbnail: "https://yt3.ggpht.com/l8CPpluol0brprHG9dZMaD7AJ2XrngeNs_oy85XUqdkLi5E3PhCu7VmP_HsRM8yUk-suL-7ImQ=s88-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "7TRFf7uUfhQ",
    title: "Swag Se Swagat",
    description: "Full Song | Tiger Zinda Hai, Salman Khan, Katrina Kaif, Vishal Dadlani, Neha Bhasin",
    views: "107538591",
    uploadDate: "Apr 13, 2018",
    category: "Hip-hop",
    channel: "YRF",
    channelThumbnail: "https://yt3.ggpht.com/b42QCAmVJ0kzNNi10_HmhsdfPEATQATS80hbLyHVJcVm6drn5pKtC6MY6wTluXi5iZ8_is5Q_Q=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "PfuL6eJNqZY",
    title: "Saturday Saturday",
    description: "Official Song - Humpty Sharma Ki Dulhania - Alia Bhatt, Varun Dhawan",
    views: "37747970",
    uploadDate: "Jun 7, 2014",
    category: "Party",
    channel: "Dharma Productions",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu9MhPBL3N1wCHUzuxoDih1GThHBetcbDpkvAg7k9_4=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "fJ9rUzIMcZQ",
    title: "Bohemian Rhapsody",
    description: "Queen | Official Video Remastered",
    views: "1532273703",
    uploadDate: "Aug 1, 2008",
    category: "Rock",
    channel: "Queen Official",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu9ITXAHJ22tIis_SQPAdtME5d3A4xnXpq5-HCkF1Q=s48-c-k-c0x00ffffff-no-rj-mo"
  },
  {
    _id: "ioNng23DkIM",
    title: "How You Like That",
    description: "Official music videio - BLACKPINK",
    views: "1148523615",
    uploadDate: "Jun 26, 2020",
    category: "K-Pop",
    channel: "BLACKPINK",
    channelThumbnail: "https://yt3.ggpht.com/hZDUwjoeQqigphL4A1tkg9c6hVp5yXmbboBR7PYFUSFj5PIJSA483NB5v7b0XVoTN9GCku3tqQ=s48-c-k-c0x00ffffff-no-nd-rj"
  },
  {
    _id: "aSkFygPCTwE",
    title: "All Summer Long",
    description: "Kid Rock - Official Music Video",
    views: "83354697",
    uploadDate: "Oct 30, 2009",
    category: "Rock",
    channel: "Kid Rock",
    channelThumbnail: "https://yt3.ggpht.com/k39MW8ieoYmBnKRzaQ2P2Y3rxdhNct_Isid3Zo4r6TI_-nvnIEtT4VpfTWlVKR41NEcPdwxo=s48-c-k-c0x00ffffff-no-nd-rj"
  },
  {
    _id: "fRh_vgS2dFE",
    title: "Sorry",
    description: "Justin Bieber - PURPOSE : The Movement",
    views: "3584844483",
    uploadDate: "Oct 23, 2015",
    category: "Pop",
    channel: "Justin Bieber",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu-MPl6e5QKTWlsnMr6_8DyE3GzjeRzUCxneF2itFA=s48-c-k-c0x00ffffff-no-rj-mo"
  },
  {
    _id: "60ItHLz5WEA",
    title: "Faded",
    description: "Officical music video - ALAN WALKER",
    views: "3340036189",
    uploadDate: "Dec 4, 2015",
    category: "Electronic",
    channel: "Alan Walker",
    channelThumbnail: "https://yt3.ggpht.com/aVVgun46AV1oXiN5TJh3lmsuWr2bKU2LW1163WB0GsZrthm4wfof6Lq8OVH5qOLq9zOQg8yj=s48-c-k-c0x00ffffff-no-nd-rj"
  },
  {
    _id: "4dsFQFCvVGU",
    title: "Kajra Re",
    description: "Full Song | Bunty Aur Babli | Aishwarya, Abhishek, Amitabh Bachchan | Shankar-Ehsaan-Loy",
    views: "253094775",
    uploadDate: "Feb 2, 2015",
    category: "Bollywood",
    channel: "YRF",
    channelThumbnail: "https://yt3.ggpht.com/b42QCAmVJ0kzNNi10_HmhsdfPEATQATS80hbLyHVJcVm6drn5pKtC6MY6wTluXi5iZ8_is5Q_Q=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "XU3eFkY1BTI",
    title: "Mohe Rang Do Laal",
    description: "Official Video Song | Bajirao Mastani | Ranveer Singh & Deepika Padukone",
    views: "58441469",
    uploadDate: "Jan 6, 2016",
    category: "Classical",
    channel: "Eros Now Music",
    channelThumbnail: "https://yt3.ggpht.com/ytc/AMLnZu9aZYKOW6IdpFeDyetrTJgHUu7S5WTmSLDlXAXym_4=s48-c-k-c0x00ffffff-no-rj"
  },
  {
    _id: "v-tjloemRzE",
    title: "Mere Tum",
    description: "Neyhal ft. Karan Malhotra | Big Indie Bang | New Hindi Song 2021",
    views: "783540",
    uploadDate: "Mar 2, 2021",
    category: "Indie",
    channel: "Big Bang Music",
    channelThumbnail: "https://yt3.ggpht.com/n4GNHYoVq5RUafTEYlVr_AR4DQXjONOlzO0XSG7p30jRbHck_Qd9_pCB8R3eW8XFDWJfm0_glQ=s48-c-k-c0x00ffffff-no-rj"
  },
];